const carouselItems = [
  {
    title: '暑期档热剧专题',
    desc: '《庆余年2》《繁花》《长安十二时辰2》领衔暑期档，古装权谋、年代商战、悬疑巨制轮番上阵，暑假追剧不剧荒。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20summer%20evening%20scene%20with%20soft%20golden%20light%20and%20dreamy%20atmosphere%2C%20abstract%20flowing%20fabric%20textures%20in%20coral%20and%20crimson%20tones%2C%20no%20text%2C%20elegant%20film%20poster%20quality&width=1000&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国产科幻崛起',
    desc: '从《三体》到《流浪地球3》，国产科幻影视迎来黄金时代。桃花视频汇聚科幻大片高清全集，带你探索星辰大海。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20cosmic%20abstract%20with%20deep%20space%20nebula%20gradients%20and%20ethereal%20light%20streaks%2C%20warm%20orange%20and%20deep%20indigo%20contrast%2C%20no%20text%2C%20cinematic%20sci-fi%20quality&width=1000&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '综艺爆款合集',
    desc: '《奔跑吧》《向往的生活》《吐槽大会》等国民综艺最新季已同步上线，笑点密集欢乐不断，周末放松首选。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20composition%20with%20playful%20floating%20shapes%20in%20warm%20amber%20and%20coral%20tones%2C%20energetic%20dynamic%20feel%2C%20no%20text%2C%20modern%20entertainment%20aesthetic&width=1000&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '日漫新番速递',
    desc: '茄子视频七月新番动漫专题全面上线，《咒术回战2》《鬼灭之刃》等热血日漫高清同步，动漫迷不可错过。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20style%20abstract%20with%20flowing%20energy%20and%20dramatic%20lighting%2C%20warm%20crimson%20and%20gold%20color%20palette%2C%20motion%20and%20speed%20feeling%2C%20no%20text%2C%20high%20quality%20illustration&width=1000&height=600&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">焦点推荐</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">精选专题内容，一站式浏览热门焦点</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer transition-all hover:bg-background-200 flex flex-col"
            >
              <div className="aspect-[5/4] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium mt-3 whitespace-nowrap">
                  查看详情 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}